import comp from "./KonvaCanvas";
export default comp;
